import { Box, Chip, Dropdown, Menu, MenuButton, MenuItem, Stack, Typography } from '@mui/joy';

export function normalizePrograms(programs) {
  if (!Array.isArray(programs)) return [];
  const seen = new Set();
  return programs.reduce((result, program) => {
    const name = String(typeof program === 'string' ? program : program?.name || '').trim();
    if (!name) return result;
    const key = program?.id != null ? `id:${program.id}` : `name:${name.toLocaleLowerCase('ru-RU')}`;
    if (seen.has(key)) return result;
    seen.add(key);
    result.push({ key, name });
    return result;
  }, []);
}

// Keep table rows compact even when a performer knows every supported program.
export default function PerformerPrograms({ programs, limit = 3 }) {
  const items = normalizePrograms(programs);
  if (!items.length) return null;
  const visible = items.slice(0, limit);
  const remaining = items.length - visible.length;
  return <Stack direction="row" sx={{ gap: 0.5, flexWrap: 'wrap', mt: 0.75, minWidth: 0 }}>
    {visible.map(program => <Chip key={program.key} size="sm" variant="soft" color="neutral"
      title={program.name} sx={{ maxWidth: '100%', '--Chip-minHeight': '22px', fontSize: 11,
        '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 } }}>
      {program.name}
    </Chip>)}
    {remaining > 0 && <Dropdown>
      <MenuButton size="sm" variant="soft" color="primary"
        aria-label={`Ещё программ: ${remaining}. Показать все программы`}
        sx={{ minHeight: 22, height: 22, px: 0.75, py: 0, borderRadius: '999px', fontSize: 11, fontWeight: 700 }}>
        +{remaining}
      </MenuButton>
      <Menu placement="bottom-start" size="sm" sx={{ zIndex: 12000, p: 0.75, borderRadius: '14px',
        width: 300, maxWidth: 'calc(100vw - 24px)', maxHeight: 320, overflowY: 'auto' }}>
        <Box sx={{ px: 1, py: 0.75 }}>
          <Typography level="title-sm">Программы исполнителя</Typography>
          <Typography level="body-xs" sx={{ color: 'text.tertiary' }}>Всего: {items.length}</Typography>
        </Box>
        {items.map(program => <MenuItem key={program.key} sx={{ borderRadius: '8px', whiteSpace: 'normal',
          overflowWrap: 'anywhere', fontSize: 12, py: 0.75 }}>{program.name}</MenuItem>)}
      </Menu>
    </Dropdown>}
  </Stack>;
}
